import Vue from 'vue';
import Loading from './loading.vue';

const LoadingBox = Vue.extend(Loading);

Loading.install = function(v) {
    let instance = new LoadingBox().$mount();
    instance.append = function() {
        document.body.appendChild(instance.$el);
    };
    instance.remove = function() {
        document.body.removeChild(instance.$el);
    };
    instance.append()
    v.prototype.$loading = instance;
    // return instance;
};

export default Loading;
